import { render, staticRenderFns } from "./DebateRooms.vue?vue&type=template&id=cca97aca&scoped=true&"
import script from "./DebateRooms.vue?vue&type=script&lang=js&"
export * from "./DebateRooms.vue?vue&type=script&lang=js&"
import style0 from "./DebateRooms.vue?vue&type=style&index=0&id=cca97aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca97aca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCol,VContainer,VRow})
